<template>
   <div class="BasicTop">
    <div class="TitleName">
        <div>{{Name}}</div>
        <!-- <div><i class="ml-1 fa fa-sort-down f-12 downItem"  ></i></div> -->
    </div>
        <slot name="Body"></slot>
   </div> 
</template>
<script>
export default {
    props: ["Name"],
    computed: {
    },
    methods: {
       
    }

}
</script>
<style lang="scss" >
.BasicTop
{
    .TitleName
    {
        color: var(--on-surface-80, rgba(0, 0, 0, 0.80));
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        line-height: 150%; /* 30px */
        letter-spacing: -0.22px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        align-self: stretch;
        margin-bottom: 16px;
    }
    .BasicTop-Card
    {
        padding:16px ;
        background: linear-gradient(87deg, #7366FF 4.35%, #0CBCE3 100.08%);
        border-radius: 16px;
        margin: 0px 0px 16px 0px;
        .Title{
                color: var(--Surface, #FFF);
                font-feature-settings: 'liga' off, 'clig' off;
                font-size: 16px;
                font-style: normal;
                font-weight: 700;
                line-height: 24px;
                letter-spacing: 0.15px;
        }
        .Span_Tips{
                color: var(--Surface, #FFF);
                font-feature-settings: 'liga' off, 'clig' off;
                font-size: 14px;
                font-style: normal;
                font-weight: 400;
                line-height: 150%;
                letter-spacing: 0.15px;
        }
        .Span_Tips_Q{
                color: var(--Surface, #FFF);
                font-feature-settings: 'liga' off, 'clig' off;
                font-size: 14px;
                font-style: normal;
                font-weight: 700;
                line-height: 150%; 
                letter-spacing: 0.15px;
        }
        .span_tips_A
        {
            color: var(--Surface, #FFF);
            font-feature-settings: 'liga' off, 'clig' off;
            /* Text/Paragraph 2 */
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 150%;
            letter-spacing: 0.15px;
        }
        .Footer_Tips_More
        {
                color: var(--Surface, #FFF);
                font-feature-settings: 'liga' off, 'clig' off;
                font-size: 14px;
                font-style: normal;
                font-weight: 400;
                line-height: 150%; 
                letter-spacing: 0.15px;
        }
        .custom_ul{
            list-style-type: none;
            margin: 10px 0px 10px 0px;
        }
        .custom_ul{
            list-style-type: none;
            margin: 10px 0px 10px 0px;
        }
        .custom_ul li::before{
            content: '•';
            color: white;
            font-size: 1.2em; 
            margin-left: 10px;
            margin-right: 10px;
        }
        .ViewEbooth
        {
            padding: 1px 8px;
            border-radius: 4px;
            border: 1px solid var(--Surface, #FFF);
            text-align: center;
            font-size: 12px;
            font-style: normal;
            font-weight: 600;
            line-height: 150%; /* 18px */
            letter-spacing: -0.132px;
            color: #FFF;
        }

    }
    .downItem
    .downItem
    {
        font-size: 20px !important;
        position: relative;
        top: -5px;
    }
 
}

</style>